export * from './IconThumbUp';
